export interface BlogPost {
    id: string;
    slug: string;
    title: string;
    description: string;
    content?: string; // For when we load it
    date: string;
    author: string;
    category: string;
    readTime: string;
    imageUrl?: string;
    imageAlt?: string;
    tags: string[];
    ctaDescription?: string; // Custom CTA description for each post
    type?: 'markdown' | 'react';
}

export const blogPosts: BlogPost[] = [
    {
        id: '10',
        slug: 'smushlabs-vs-chatbase',
        title: 'Why We Should Choose SmushLabs Over Chatbase for Our AI Customer Support',
        description: 'An executive summary on balancing excellent customer support with smart cost management when choosing between SmushLabs and Chatbase.',
        date: '2026-08-25',
        author: 'Asif Farhan Khan, Founder',
        category: 'Market Research',
        readTime: '4 min read',
        tags: ['Competitor Analysis', 'Cost Management', 'Customer Support', 'AI Strategy'],
        type: 'react'
    },
    {
        id: '9',
        slug: 'ai-support-platform-shift',
        title: 'Is AI a bubble ?',
        description: 'Is AI a bubble or the next ubiquitous platform? We analyze the shift from simple chatbots to intelligent customer support layers, inspired by Benedict Evans\' "AI Eats the World".',
        date: '2025-12-18',
        author: 'Asif Farhan Khan, Founder',
        category: 'Market Research',
        readTime: '5 min read',
        tags: ['Platform Shift', 'Customer Support', 'AI Strategy', 'Benedict Evans'],
        imageUrl: '/blog-images/Is AI a Bubble.png',
        ctaDescription: 'Don\'t get left behind in the platform shift. SmushChat helps you build the new layer of customer support—intelligent, active, and automated. Start building your AI support layer today.',
        type: 'react'
    },
    {
        id: '8',
        slug: 'tefl-institute-technical-case-study',
        title: 'Building Intelligence: The TEFL Institute Development Journey',
        description: 'A technical deep-dive into engineering a multilingual AI assistant: development roadmap, architecture decisions, and challenges overcome in building an 80+ language customer support system.',
        date: '2025-11-29',
        author: 'Asif Farhan Khan, Founder',
        category: 'Case Study',
        readTime: '12 min read',
        tags: ['Case Study', 'Technical', 'AI Development', 'Architecture', 'Education'],
        imageUrl: '/blog-images/tefl-institute-team-customer-story.webp',
        imageAlt: 'The TEFL Institute team in 2025',
        ctaDescription: 'Join the TEFL Institute to automate support, capture more leads, and scale without increasing headcount.',
        type: 'react'
    },
    {
        id: '7',
        slug: 'premier-tefl-case-study',
        title: 'How Premier TEFL Automated 70% of Student Support',
        description: 'See how Premier TEFL used SmushChat to automate 70% of student queries, reduce response times by 45%, and cut operational costs while boosting engagement.',
        date: '2025-11-28',
        author: 'Asif Farhan Khan, Founder',
        category: 'Case Study',
        readTime: '5 min read',
        tags: ['Case Study', 'Education', 'Automation', 'Support'],
        imageUrl: '/blog-images/premier-tefl-team-customer-story.webp',
        imageAlt: 'The Premier TEFL team',
        ctaDescription: 'Want to see how SmushChat could work with your content? Request a free custom demo built from your public website.',
        type: 'react'
    },
    {
        id: '6',
        slug: 'making-sense-of-ai-model-explosion-2025',
        title: 'Making Sense of the AI Model Explosion: What Founders Actually Need to Know',
        description: 'Four frontier AI models dropped in two weeks. Here\'s what Grok 4.1, GPT-5.1, Gemini 3, and Claude Opus 4.5 actually mean for your business.',
        date: '2025-11-25',
        author: 'Asif Farhan Khan, Founder',
        category: 'AI & Automation Insights',
        readTime: '8 min read',
        tags: ['AI Models', 'Grok', 'OpenAI', 'Founders', 'LLMs'],
        imageUrl: '/blog-images/Ai-explosion-nov-2025-blog-infographic.png',
        ctaDescription: 'Ready to leverage frontier AI models without the complexity? SmushChat gives you access to the latest models through one simple interface—no model lock-in, no complex integrations. Start building smarter customer experiences today.',
        type: 'react'
    }
];
